import { __rest } from "tslib";
import cx from 'classnames';
import { mapValues } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Guide.module.css';
export default function Extension(_a) {
    var side = _a.side, zoomScale = _a.zoomScale, layout = __rest(_a, ["side", "zoomScale"]);
    var isVertical = side === 'left' || side === 'right';
    var className = cx(styles.guide, {
        'borderWidth-0': true,
        'borderLeftWidth-1': isVertical,
        'borderTopWidth-1': !isVertical,
    });
    var style = mapValues(layout, function (v) { return zoomScale * v; });
    if (side === 'right') {
        style.left -= 1;
    }
    else if (side === 'bottom') {
        style.top -= 1;
    }
    return React.createElement("div", { className: className, style: style });
}
Extension.propTypes = {
    side: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    zoomScale: PropTypes.number.isRequired,
};
